import { Slider } from 'antd';
import 'antd/lib/slider/style/css';
import './index.less';

export default Slider;
